import { useEffect, useState } from "react";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useGetUserId } from "../hooks/useGetUserId";

export const Home = () => {
  const [cards, setCards] = useState([]);
  const [savedCards, setSavedCards] = useState([]);
  const [wishedCards, setWishedCards] = useState([]);
  const [cookies] = useCookies(["access_token"]);
  const userID = useGetUserId();

  // ADD WISHLIST, NEEDED IN CARDS.JS AS WELL
  useEffect(() => {
    const fetchCard = async () => {
      try {
        const response = await axios.get("http://localhost:3001/cards");
        setCards(response.data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchSavedCards = async () => {
      try {
        const response = await axios.get(
          `http://localhost:3001/cards/savedCards/ids/${userID}`
        );
        setSavedCards(response.data.savedCards);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchWishedCards = async () => {
      try {
        const response = await axios.get(
          `http://localhost:3001/cards/wishedCards/ids/${userID}`
        );
        setWishedCards(response.data.wishedCards);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCard();
    if (cookies.access_token) {
      fetchSavedCards();
      fetchWishedCards();
    }
  }, [cookies, userID]);

  const saveCard = async (cardID) => {
    try {
      const response = await axios.put(
        "http://localhost:3001/cards",
        {
          cardID,
          userID,
        },
        { headers: { authorization: cookies.access_token } }
      );
      setSavedCards(response.data.savedCards);
    } catch (err) {
      console.error(err);
    }
  };

  const wishCard = async (cardID) => {
    try {
      const response = await axios.put("http://localhost:3001/cards/wish", {
        cardID,
        userID,
      });
      setWishedCards(response.data.wishedCards);
    } catch (err) {
      console.error(err);
    }
  };

  const isCardSaved = (id) => savedCards.includes(id);
  const isCardWished = (id) => wishedCards.includes(id);

  return (
    <div>
      {" "}
      <h1>All Cards</h1>
      <ul>
        {cards.map((card) => (
          <li key={card._id}>
            <div id="cardInfo">
              <h2>{card.setName}</h2>
              <button
                onClick={() => saveCard(card._id)}
                disabled={isCardSaved(card._id)}
              >
                {isCardSaved(card._id) ? "In Collection" : "Add to collection"}
              </button>
              <button
                onClick={() => wishCard(card._id)}
                disabled={isCardWished(card._id)}
                hidden={isCardSaved(card._id)}
              >
                {isCardWished(card._id) ? "In Wishlist" : "Add to wishlist"}
              </button>
            </div>
            <div>
              <h2>{card.name}</h2>
            </div>
            <img src={card.imageUrl} alt={card.name} />
            <h3>Market Price: ${card.price}</h3>
          </li>
        ))}
      </ul>
    </div>
  );
};
